import React from 'react'
import "./Placement.css"
const Placement = () => {
  const placement=[
   {
     name:"Vicky",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Blinkit private ltd",
    },
    {
     name:"Chandan Thakur",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Globe Capacitors Pvt Ltd ",
    },
   {
     name:"RAVI KUMAR",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"AIS WINDOW",
    },
    {
     name:"SUMIT  KUMAR",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"SIETZ ",
    },
   {
     name:"Rahul",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Wabtech pvt Ltd  sector 25 plot number 20",
    },
    {
     name:"Sunil Kumar ",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Embroidery operator ",
    },
   {
     name:"Arun Sharma",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Avon Techno fab ( General manager) ",
    },
    {
     name:"Kapil Rathi",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Reliance JIO Engineer",
    },
   {
     name:"Komal Saini",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Renew Power",
    },
    {
     name:"Deepak",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Escorts Kubota limited as an Assistant Manager ",
    },
   {
     name:"abhay Chauhan",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Pharmaceutical companies ",
    },
    {
     name:"Sachin",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Ascentech Lightening Solution",
    },
   {
     name:"GHANSHYAM",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Operator training mahindra Ltd ",
    },
    {
     name:"Mayank goyal",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Jbm auto limted ",
    },
   {
     name:"Sandeep Sharma ",
     Course:"B.tech",
     Package:"12-15lakh",
     Company:"Amrita Hospitals Faridabad As a Project Engineer (MEP)",
    },
    {
     name:"Sanjay Kumar",
     Course:"B.tech",
     Package:"7 Lakh",
     Company:"Prescomec Autocomp Pvt.Ltd",
    },
   {
     name:"Neeraj Sharma",
     Course:"B.tech",
     Package:" 6 Lakh",
     Company:"R.K Industries",
    },
   {
     name:"Akash Kumar Pandey",
     Course:"B.tech",
     Package:"4.5 Lakh",
     Company:"Aew Protech PvT.Ltd",
    },
   {
     name:"Deepak Kumar Sharma",
     Course:"B.tech",
     Package:"8 Lakh",
     Company:"Bansal Wire Industries Ltd",
    },
   {
     name:"Ankit",
     Course:"B.tech",
     Package:"8 Lakh",
     Company:"JCB Pasco",
    },
   {
     name:"Sanjay Kumar",
     Course:"B.tech",
     Package:"8 Lakh",
     Company:"Prescomec Autocomp Pvt.Ltd",
    },
    {
      name:"Manish Kumar ",
      Course:"",
      Package:"",
      Company:"Larsen & Toubro Ltd.",
    },
    {
      name:"Nandan Sasmal ",
      Course:"",
      Package:"",
      Company:"Larsen & Toubro Ltd.",
    },
    {
      name:"DEEPAK",
      Course:"",
      Package:"",
      Company:"JCB INDIA LTD",
    },
    {
      name:"PRIYANSHU NEGI",
      Course:"",
      Package:"",
      Company:"JCB INDIA LTD",
    },
    {
      name:"Anil Kumar ",
      Course:"",
      Package:"",
      Company:"JCB INDIA LTD",
    },
    {
      name:"SACHIN SHARMA",
      Course:"",
      Package:"",
      Company:"MARUTI SUZUKI ",
    },
    {
      name:"DEEPIKA",
      Course:"",
      Package:"",
      Company:"HERO MOTO CORP ",
    },
    {
      name:"KAJOL GUSAIN",
      Course:"",
      Package:"",
      Company:"HERO MOTO CORP ",
    },
    {
      name:"Vishal Singh ",
      Course:"",
      Package:"",
      Company:"JBM Industries Pvt. Ltd.",
    },
    {
      name:"GULSHAN SHARMA",
      Course:"",
      Package:"",
      Company:"BCH INDIA LTD ",
    },
    {
      name:"ANSHUL RAKHEJA",
      Course:"",
      Package:"",
      Company:"INFOSYS LTD ",
    },
    {
      name:"AJMAT HUSAIN",
      Course:"",
      Package:"",
      Company:"Escort kubota Ltd",
    },
    {
      name:"SAGAR",
      Course:"",
      Package:"",
      Company:"EScort kubota TRACTOR Ltd",
    },
    {
      name:"GHANSHYAM KUMAR",
      Course:"",
      Package:"",
      Company:"YAZAKI INDIA PVT LTD",
    },
    {
      name:"JATIN KAUSHIK",
      Course:"",
      Package:"",
      Company:"Pranav vikash india pvt ltd",
    },
    {
      name:"AMAN RAGHAV",
      Course:"",
      Package:"",
      Company:"PPAP AUTOMATIVE LTD",
    },
    {
      name:"ANKUSH",
      Course:"",
      Package:"",
      Company:"IMPEX HITECH RUBBER PVT LTD",
    },
    {
      name:"ARYAN CHAUHAN",
      Course:"",
      Package:"",
      Company:"RAJDOOT CABLES ",
    },
    {
      name:"AVINASH SINGH",
      Course:"",
      Package:"",
      Company:"BSES RAJDHANI POWER LTD ",
    },
    {
      name:"DEEPANSHU BIZENIA",
      Course:"",
      Package:"",
      Company:"AGILENT TECHNOLOGIES ",
    },
    {
      name:"YATIN",
      Course:"",
      Package:"",
      Company:"SADHU FORGIN LTD",
    },
    {
      name:"VIKASH BHARDWAJ",
      Course:"",
      Package:"",
      Company:"R.SINGH & ASSOCIATED PVT.LTD",
    },
    {
      name:"RAVIRANJAN KUMAR",
      Course:"",
      Package:"",
      Company:"BITS N BITE SOFT PVT LTD",
    },
    {
      name:"AVINASH",
      Course:"",
      Package:"",
      Company:"CMS",
    },
    {
      name:"tervinder",
      Course:"",
      Package:"",
      Company:"blinkit",
    },
    {
      name:"PRIYANKA RAO",
      Course:"",
      Package:"",
      Company:"DYNAMIC INDUCTUION CORME",
    },
    {
      name:"AMAN MISHRA",
      Course:"",
      Package:"",
      Company:"PRANAV VIKAS PRIVATE",
    },
    {
      name:"DHIRENDER ",
      Course:"",
      Package:"",
      Company:"L & T  COMPANY",
    },
    {
      name:"HARSHIT PATHAK",
      Course:"",
      Package:"",
      Company:"JBM INDUSTRIES PVT.LTD",
    },
    {
      name:"CHATTER PAL",
      Course:"",
      Package:"",
      Company:"RAMINDER VIR PARASHAR",
    },
    {
      name:"NITISH PATEL",
      Course:"",
      Package:"",
      Company:"DEGINER ENGINEER",
    },
    {
      name:"MAYANK GOYAL",
      Course:"",
      Package:"",
      Company:"JBM AUTO PRIVATE LIMITED",
    },
    {
      name:"PREM SAGAR",
      Course:"",
      Package:"",
      Company:"ESCORT KUBOTA LIMITED",
    },
    {
      name:"AMIT KAUSHIK",
      Course:"",
      Package:"",
      Company:"HYUNDAI",
    },
    {
      name:"SUMIT",
      Course:"",
      Package:"",
      Company:"AIR INDIA",
    },
    {
      name:"GAURAV SINGH",
      Course:"",
      Package:"",
      Company:"WORKINGB IN PUC",
    },
    {
      name:"ROHIT KUMAR",
      Course:"",
      Package:"",
      Company:"SAWAKA SURFACE",
    },
    {
      name:"MOHIT SINGH",
      Course:"",
      Package:"",
      Company:"ATECH AUTOMATION",
    },
    {
      name:"MILIND ",
      Course:"",
      Package:"",
      Company:"WHIPOOL INDIA",
    },
    {
      name:"MUKESH KUMAR",
      Course:"",
      Package:"",
      Company:"RBM INDUSTRIES",
    },
    {
      name:"KAPIL",
      Course:"",
      Package:"",
      Company:"TECHNOEX INDUSTRIAL",
    },
    {
      name:"DEEPAK MAKHIJA",
      Course:"",
      Package:"",
      Company:"BENGAL INDUSTRIES",
    },
    {
      name:"SATYA NARYAN",
      Course:"",
      Package:"",
      Company:"IMPERIAL AUTO INDUSTRIES LTD",
    },
    {
      name:"SUMIT JINDAL",
      Course:"",
      Package:"",
      Company:"BHARAT GAS LIMITED",
    },
    {
      name:"BHUPENDER SINGH",
      Course:"",
      Package:"",
      Company:"ESCORTS KUBOTA",
    },
    {
      name:"HIMANSHU GAUR",
      Course:"",
      Package:"",
      Company:"SHARMA ENGG AND FABRICATION ",
    },
    {
      name:"KRISHAN KUMAR",
      Course:"",
      Package:"",
      Company:"JCB INDIA LTD PVT",
    },
    {
      name:"ANKUR CHUDHARY",
      Course:"",
      Package:"",
      Company:"SANDEN VIKAS INDIA PVT.LTD",
    },
    {
      name:"Anil Kumar ",
      Course:"",
      Package:"",
      Company:"NISHANTH I INDUSTRIES",
    },
    {
      name:"Vishal Singh ",
      Course:"",
      Package:"",
      Company:"JBM INDUSTRIES PVT.LTD",
    },
    {
      name:"ROHIT ",
      Course:"",
      Package:"",
      Company:"NAPINO AUTO & ELECTRONIC",
    },
    {
      name:"Anil Kumar ",
      Course:"",
      Package:"",
      Company:"JCB INDIA LIMITED",
    },
    {
      name:"ADITIYA GUPTA",
      Course:"",
      Package:"",
      Company:"CODING NINJA",
    },
    {
      name:"BHAWNA",
      Course:"",
      Package:"",
      Company:"ARGUS TECHNOLOGY PVT. LTD",
    },
    {
      name:"NAVEEN KUMAR",
      Course:"",
      Package:"",
      Company:"JCB INDIA LTD",
    },
    {
      name:"AKASH KUMAR ",
      Course:"",
      Package:"",
      Company:"LARSON AND TURBO",
    }
  ]
  return (
    <div className='main-container-placement'>
    <div className='container-placement course-btech'> 
      <h1 className='thead1' color={{color:"#05365e"}}>Placement Details</h1> 
      <div className='table-wrapper'>
        <table className='download-table'>
          <thead>
            <tr>
              <th>Name</th>
              <th>Course</th>
              <th>Package</th>
              <th>Company</th>
            </tr>
          </thead>

          <tbody className='company'>
            {placement.map((item, index) => (
              <tr key={index}>
                <td className='align-left company-col'>{item.name}</td>
                <td>{item.Course}</td>
                <td>{item.Package}</td>
                <td className='align-left company-col'>{item.Company}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  )
}

export default Placement
